import Image from 'next/image';
import type { ReactNode } from 'react';
import { Box } from '@mui/material';
import { ComponentIntroHero } from '@/app/lib/generated/graphql-types';
import { MediaRef } from '@/app/features/shared/__to_be_integrated/types/general/media/media';
import MediaView from '@/app/features/shared/media-view/ui/public/MediaView.public';
import { ShopHeroBackgroundFrame, ShopHeroFrame } from '@/app/features/sites/shop/ui/shared/ShopFrames';

export default function ShopHero({
    intro,
    content,
    backgroundOverlay,
}: {
    intro: Omit<ComponentIntroHero, 'image'> & { image: MediaRef };
    content: ReactNode;
    backgroundOverlay?: ReactNode;
}) {
    return (
        <ShopHeroFrame
            content={content}
            background={(
                <ShopHeroBackgroundFrame>
                    <MediaView
                        src={intro.image}
                        fill
                        showLoadingSpinner={false}
                        objectFit="cover"
                        slots={{
                            image: {
                                priority: true,
                                fetchPriority: 'high',
                                loading: 'eager',
                                sizes: '100vw',
                                quality: 75,
                            },
                        }}
                    />
                    {backgroundOverlay}
                    <Box
                        sx={{
                            position: 'absolute',
                            right: { xs: 8, md: 16 },
                            bottom: { xs: 8, md: 16 },
                            zIndex: 101,
                            width: { xs: 120, md: 210 },
                            aspectRatio: '4 / 3',
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                            overflow: 'hidden',
                        }}
                    >
                        <Image
                            src="/assets/fairtrade-stadt-erding.jpg"
                            alt="Fairtrade-Stadt Erding"
                            fill
                            sizes="(max-width: 600px) 120px, 210px"
                            style={{ objectFit: 'contain' }}
                        />
                    </Box>
                </ShopHeroBackgroundFrame>
            )}
        />
    );
}
